import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import IconButtonAbsoluteMenu from '__components/Tables/Big/IconButtonAbsoluteMenu';
import Icon from '__components/Kizen/Icon';
import { useToast } from '__components/ToastProvider';
import { colorsButton } from 'app/colors';
import { buildClaudePrompt, type ClaudePromptTarget } from './claudePrompt';

export const CopyPromptMenu: FC<{ target: ClaudePromptTarget }> = ({
  target,
}) => {
  const { t } = useTranslation();
  const [showToast] = useToast();

  const handleCopy = () => {
    navigator.clipboard
      .writeText(buildClaudePrompt(target, window.location.origin))
      .then(
        () => showToast({ message: t('Copied') }),
        () => {}
      );
  };

  return (
    <IconButtonAbsoluteMenu
      position="left"
      sizing="dense"
      color={colorsButton.iconGray}
      onChange={handleCopy}
      options={[{ value: 'copy_prompt', label: t('Copy prompt') }]}
      title={t('Options')}
      data-qa-id="ai-block-panel-header-menu"
    >
      <Icon icon="three-dot" />
    </IconButtonAbsoluteMenu>
  );
};
